'use client';

import React__default from 'react';
import { transformToLatin } from '../../../../../Utils/helpers.js';

/**
 * Highlight matching keyword in children
 * - Case sensitive
 * - Can search even with or without unicode (transform to latin)
 * By: ThienTD
 *
 * @param {string} keyword
 * @param {string} children
 * @returns {React.ReactNode} that highlight matching keyword in children
 */
var HighlightText = function (params) {
    var _a = params.keyword, keyword = _a === void 0 ? '' : _a, _b = params.children, children = _b === void 0 ? '' : _b;
    var formattedKeyword = transformToLatin(keyword === null || keyword === void 0 ? void 0 : keyword.trim()).toLowerCase();
    if (formattedKeyword === '') {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    // formattedKeyword have value
    var convertedName = transformToLatin(children).toLowerCase();
    var matchIndex = convertedName === null || convertedName === void 0 ? void 0 : convertedName.indexOf(formattedKeyword);
    if (matchIndex === -1) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    // Split children item to 3 parts (before, matched, after)
    var beforeMatchedText = children === null || children === void 0 ? void 0 : children.substring(0, matchIndex);
    var matchedText = children === null || children === void 0 ? void 0 : children.substring(matchIndex, matchIndex + (formattedKeyword === null || formattedKeyword === void 0 ? void 0 : formattedKeyword.length));
    var afterMatchedText = children === null || children === void 0 ? void 0 : children.substring(matchIndex + (formattedKeyword === null || formattedKeyword === void 0 ? void 0 : formattedKeyword.length), children === null || children === void 0 ? void 0 : children.length);
    // Join it again with highlight strong
    return (React__default.createElement(React__default.Fragment, null,
        beforeMatchedText,
        React__default.createElement("strong", { style: { fontWeight: 700 } }, matchedText),
        afterMatchedText));
};

export { HighlightText as default };
//# sourceMappingURL=index.js.map
